/**
 * Server-side table sorting, carried in the URL like every list filter: a sorted list survives
 * a reload, can be shared, and is exactly what the list endpoint receives. The backend reads the
 * same two params (`BaseRepository::applySort()` in amer-laravel) against its own allowlist.
 */
export const SORT_BY_PARAM = "sort_by";
export const SORT_DIRECTION_PARAM = "sort_direction";

export const SORT_DIRECTION = Object.freeze({ ASC: "asc", DESC: "desc" });

// AntD calls a column's order "ascend" / "descend"; the API takes "asc" / "desc".
const ORDER_BY_DIRECTION = {
  [SORT_DIRECTION.ASC]: "ascend",
  [SORT_DIRECTION.DESC]: "descend",
};
const DIRECTION_BY_ORDER = {
  ascend: SORT_DIRECTION.ASC,
  descend: SORT_DIRECTION.DESC,
};

/** AntD `sortOrder` for the column sorting by `sortKey`: null unless the URL sorts by it. */
export const getColumnSortOrder = (searchParams, sortKey) => {
  if (searchParams.get(SORT_BY_PARAM) !== sortKey) return null;

  return searchParams.get(SORT_DIRECTION_PARAM) === SORT_DIRECTION.ASC
    ? ORDER_BY_DIRECTION[SORT_DIRECTION.ASC]
    : ORDER_BY_DIRECTION[SORT_DIRECTION.DESC];
};

/**
 * A copy of `searchParams` sorted by `sortKey` in AntD's `order`, or unsorted when `order` is
 * empty (AntD's third click). The page is dropped: a new order starts from its first page.
 */
export const withSort = (searchParams, sortKey, order) => {
  const next = new URLSearchParams(searchParams);
  next.delete("page");

  if (sortKey && DIRECTION_BY_ORDER[order]) {
    next.set(SORT_BY_PARAM, sortKey);
    next.set(SORT_DIRECTION_PARAM, DIRECTION_BY_ORDER[order]);
  } else {
    next.delete(SORT_BY_PARAM);
    next.delete(SORT_DIRECTION_PARAM);
  }

  return next;
};
